import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Sparkles } from "lucide-react";

const MOOD_LABEL = { great: "Really good", ok: "Okay", not_good: "Not great", struggling: "Struggling" };

export default function WeeklyRecapCard() {
  const [recap, setRecap] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/wellbeing/recap");
        setRecap(data);
      } catch (e) {
        /* silent */
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return null;
  if (!recap) return null;

  const s = recap.stats || {};
  const moods = s.moods || {};

  return (
    <section
      className="mt-6 rounded-3xl p-8 border border-[#2E9D96]/20 shadow-sm bg-gradient-to-br from-white to-[#EAF5F3]"
      data-testid="weekly-recap-card"
    >
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-2xl bg-[#0E1417] text-[#3FC1B7] flex items-center justify-center shrink-0">
          <Sparkles size={20} />
        </div>
        <div>
          <h2 className="font-display text-2xl text-slate-800">Your week with Zaf</h2>
          <p className="text-slate-500 text-sm mt-0.5">A gentle look back at the last 7 days.</p>
        </div>
      </div>

      <p className="mt-5 text-[15px] leading-relaxed text-slate-700 whitespace-pre-wrap" data-testid="weekly-recap-summary">
        {recap.summary}
      </p>

      <div className="mt-6 flex flex-wrap gap-2.5" data-testid="weekly-recap-stats">
        <Stat label="Check-ins" value={s.checkins ?? 0} />
        <Stat label="Chats with Zaf" value={s.messages ?? 0} />
        {Object.entries(moods).map(([k, v]) => (
          <Stat key={k} label={MOOD_LABEL[k] || k} value={v} tint />
        ))}
      </div>
    </section>
  );
}

function Stat({ label, value, tint }) {
  return (
    <div className={`rounded-2xl px-4 py-2.5 border ${tint ? "border-[#2E9D96]/20 bg-[#2E9D96]/[0.06]" : "border-slate-200 bg-white"}`}>
      <span className="font-display text-xl text-slate-800">{value}</span>
      <span className="ml-2 text-sm text-slate-500">{label}</span>
    </div>
  );
}
